import React from 'react';
import ReactHighcharts from 'react-highcharts';
//import Highlight from 'react-highlight';
import Select from 'react-select';
import {getProgressReport, getBenchmarkReport} from 'Services/ReportService';
import {getProgressReportConfig, getBenchmarkReportConfig} from './NativeReportConfig';
import FaAngleLeft from 'react-icons/lib/fa/angle-left';
import { getUserData } from "Services/API";
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";

const reportColors = {
  GOOD: '#00fad2',
  AVERAGE: '#cfff76',
  POOR: '#ff3143',
};

const sortTypes = {
  NAME: 'name',
  SCORE: 'score',
};

const reportTypes = {
  PROGRESS: 'progress',
  BENCHMARK: 'benchmark',
}

export default class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportConfig: {},
      reportData: {},
      pageTitle: "",
      selectedSort: { value: sortTypes.SCORE, label: 'Sort by Score' },
    }
    this.handleSort = this.handleSort.bind(this);
  }

  componentDidMount(){
    const { reportType, reportId } = this.props.match.params;
    this.loadReport(reportType, reportId);
  }

  componentDidUpdate(prevProps){
    const { reportType, reportId } = this.props.match.params;
    if(this.props !== prevProps && reportType && reportId
      && (reportType !== prevProps.match.params.reportType || reportId !== prevProps.match.params.reportId)){
      this.loadReport(reportType, reportId);
    }
  }

  loadReport(reportType, reportId){
    let userData = getUserData();
    let reportConfig = {};
    let reportData = {};
    let pageTitle = "";
    if(reportType === reportTypes.BENCHMARK){
      reportData = getBenchmarkReport(reportId);  //TODO: make this async
      console.log("reportData: ", reportData);
      reportConfig = getBenchmarkReportConfig(reportData, sortTypes.SCORE, this.props.history);
      pageTitle = "Benchmark Report";
    } else {
      reportData = getProgressReport(reportId);  //TODO: make this async
      console.log("reportData: ", reportData);
      reportConfig = getProgressReportConfig(reportData);
      pageTitle = userData.firstName + "'s Progress Report";
    }
    this.setState({
      reportConfig: reportConfig,
      pageTitle: pageTitle,
      reportData: reportData,
    });
  }

  handleSort(sortType){
    let newReportConfig = getBenchmarkReportConfig(this.state.reportData, sortType.value, this.props.history);
    this.setState({
      reportConfig: newReportConfig,
      selectedSort: sortType,
    });
  }

  getControls(){
    if (this.props.match.params.reportType === reportTypes.BENCHMARK){
      let options = [
        { value: sortTypes.NAME, label: 'Sort by Name' },
        { value: sortTypes.SCORE, label: 'Sort by Score' },
      ];
      return (
        <Select
          menuPlacement="auto"
          className="sortSelect"
          classNamePrefix="sortSelect"
          value={this.state.selectedSort}
          onChange={this.handleSort}
          options={options}
          placeHolder="Sort by..."
        />
      );
    } else {
      return null;
    }
  }

  getBackButton(){
    if(this.props.return){
      let goBack = function (){
        this.props.history.push(this.props.return);
      }
      return(
        <div className="backButton" {...doNotUseAccessibleStaticElementInteractions({onClick: goBack.bind(this)})}>
          <FaAngleLeft size="48" className="backButtonSvg"/>
        </div>
      );
    }
  }

  render(){
    return (
      <div className="reports">
        <div className="header">
          {this.getBackButton()}
          {this.state.pageTitle}
          <div className="controls">
            {this.getControls()}
          </div>
        </div>
        <div className="chartContainer">
          <ReactHighcharts isPureConfig={true} config={this.state.reportConfig} className="chart" />
        </div>
      </div>
    );
  }
}